const normalizeDeletedFileIds = deletedFileIds => {
  return Array.isArray(deletedFileIds)
    ? [...new Set(deletedFileIds.filter(id => id !== undefined && id !== null))]
    : [];
};

export const addDeletedFile = (deletedFileIds, fileId) => {
  if (fileId === undefined || fileId === null) return normalizeDeletedFileIds(deletedFileIds);

  return [...new Set([...normalizeDeletedFileIds(deletedFileIds), fileId])];
};

export const removeDeletedFile = (deletedFileIds, fileId) => {
  return normalizeDeletedFileIds(deletedFileIds).filter(id => id !== fileId);
};

export const toggleDeletedFile = (deletedFileIds, fileId) => {
  const normalizedDeletedFileIds = normalizeDeletedFileIds(deletedFileIds);

  return normalizedDeletedFileIds.includes(fileId)
    ? removeDeletedFile(normalizedDeletedFileIds, fileId)
    : addDeletedFile(normalizedDeletedFileIds, fileId);
};

export const useDeleteFiles = () => ({
  normalizeDeletedFileIds,
  addDeletedFile,
  removeDeletedFile,
  toggleDeletedFile,
});
